/*
  Import Tailwind's base styles into the browser.
*/
import "./src/styles/globals.css"
